import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { formatAsGermanDate } from '~/functions/helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencePeriodPill',
  props: {
    startDate: null,
    endDate: null,
    label: null
  },
  setup(__props: any) {

const props = __props as {
  startDate?: string | null
  endDate?: string | null
  label?: string | null
};



const hasRange = computed(
  () => !!props.startDate && !!props.endDate,
)

const rangeText = computed(() => {
  if (!props.startDate || !props.endDate) return ''
  const start = formatAsGermanDate(props.startDate)
  const end = formatAsGermanDate(props.endDate)
  if (!start || !end) return ''
  return `${start} – ${end}`
})

return { __sfc: true,props, hasRange, rangeText }
}

})